import moment from 'moment'

export default {
  filters: {
    moment(value, format = 'DD MMM, YYYY') {
      return moment(value).format(format)
    },
  },
}
